//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "messaging/messenger",
  "./template/basicDepartmentInfoTemplate.html",
], function (Marionette, Messenger, BasicDepartmentInfoTemplate) {
  "use strict";

  var BasicDepartmentInfoView = {};

  BasicDepartmentInfoView.basicDepartmentInfoView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: BasicDepartmentInfoTemplate,
    showError: function (div, errorMessage) {
      this.$el
        .find(div)
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    textboxes: {
      "#name": {
        enableSelector: ["#nameLabel", "#name"],
        modelAttribute: "name",
        placeholder: "admin.department.name",
        textArea: false,
      },
      "#description": {
        enableSelector: ["#descriptionLabel", "#description"],
        modelAttribute: "description",
        placeholder: "admin.department.description",
        textArea: false,
      },
      "#taskDescription": {
        enableSelector: ["#taskDescriptionLabel", "#taskDescription"],
        modelAttribute: "taskDescription",
        placeholder: "admin.department.taskDescription",
        textArea: false,
      },
    },
    triggers: {
      "click #btnShowHistory": "show:history",
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:date:long", date);
      },
    },
    nameError: function (errorMessage) {
      this.$el
        .find("#name")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return BasicDepartmentInfoView;
});
